import React from "react";
import "./StatusOfCompliance.scss";

import CG_Certificate2024 from "../../../files/status-of-comliance/Corporate Governance Certificate2024.pdf";

import { Link } from "react-router-dom";

const StatusOfCompliance = () => {
  return (
    <>
      <div className="statusOfCompliance">
        <div className="container">
          <div className="heading_box">Status Of Compliance</div>
          <div className="my-5 text-center">
            <div className="report_link">
              <ul>
                <li>
                  <a href={CG_Certificate2024} target="_blank" rel="noreferrer">
                    Corporate Governance Certificate 2024
                  </a>
                </li>
                <li>
                  {/* <a href={CG_Certificate2024} target="_blank" rel="noreferrer">
                    Corporate Governance Certificate 2023
                  </a> */}
                  <Link to="/CorpGovernance-certificate/2023">
                    Corporate Governance Certificate 2023
                  </Link>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default StatusOfCompliance;
